import type { IconData } from '@stacksjs/iconify-core'

export const notificationAlert: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"3\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M32.953 30c-.07 4.303-.21 7.538-.342 9.808c-.147 2.52-1.973 4.53-4.487 4.77C25.809 44.8 22.477 45 18 45s-7.81-.2-10.124-.422c-2.514-.24-4.34-2.25-4.487-4.771C3.2 36.583 3 31.413 3 24s.2-12.583.389-15.807c.147-2.52 1.973-4.53 4.487-4.771C10.191 3.2 13.523 3 18 3q2.177.001 4 .057\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"m12.266 3.122l.406 3.25A3 3 0 0 0 15.649 9H19\"/><path stroke-linecap=\"round\" d=\"M16 39h4\"/><path d=\"M23 14a11 11 0 1 0 22 0a11 11 0 1 0-22 0\"/><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M34 18v1m0-5V9\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default notificationAlert
